import gql from "graphql-tag";

export const MY_LEAVE_UPSERT_EMAILS_BY_COMPANY = gql`
  mutation upsertEmailsByCompany($emails: [EmailByCompanyInput]) {
    upsertEmailsByCompany(emails: $emails)
  }
`;
